import { action, observable } from "mobx";
import Validation, { ValidationTypes } from "../utils/Validation";

class Immersive3dTourPanorama extends Validation {
  @observable id;

  @observable upload;

  @observable url;

  @observable size;

  @observable metadata;

  @observable isSelected;

  constructor(data) {
    super();
    this.setData(data);
    this.validates();
  }

  internalValidates() {
    const { exifReadable, equirectangular, dateTimeOriginal, width } = this.metadata;

    const isTooSmall = width && width < 3000;

    if (!exifReadable && isTooSmall) {
      // Both together almost always mean a web export or thumbnail rather than the camera original
      this.addValidationMessage(
        `Image ${this.upload.name} looks like a thumbnail or a low-resolution copy (${width}px wide, no camera EXIF data). Please upload the original file straight from your 360 camera.`,
        ValidationTypes.ERROR,
      );
    } else if (!exifReadable) {
      this.addValidationMessage(
        `Image ${this.upload.name} is missing EXIF data, or it could not be read. This usually happens when the image was exported, edited or downloaded from a website. Please upload the original file straight from your 360 camera.`,
        ValidationTypes.ERROR,
      );
    }

    if (!equirectangular) {
      this.addValidationMessage(
        `Image ${this.upload.name} does not seem to be equirectangular. Please check to make sure the image width is exactly 2 times the height.`,
        ValidationTypes.ERROR,
      );
    }

    if (isTooSmall && exifReadable) {
      this.addValidationMessage(
        `Image ${this.upload.name} is only ${width}px wide, panoramas must be at least 3000px wide. It may be a thumbnail or a low-resolution copy. Please upload the original file straight from your 360 camera.`,
        ValidationTypes.ERROR,
      );
    }

    if (!dateTimeOriginal) {
      this.addValidationMessage(
        `Image ${this.upload.name} is missing image original date & time. Sorting by date & time might not work as expected.`,
        ValidationTypes.INFO,
      );
    }
  }

  @action
  setData(data) {
    const { id, upload, url, size, metadata, isSelected = false } = data;
    this.id = id;
    this.upload = upload;
    this.url = url;
    this.size = size;
    this.metadata = metadata;
    this.isSelected = isSelected;
  }

  @action
  setIsSelected(isSelected) {
    this.isSelected = isSelected;
  }
}

export default Immersive3dTourPanorama;
